import type { GodPresentationEvent } from '../rendering/types';

export interface GodCardTiming {
  readonly enterMs: number;
  readonly holdMs: number;
  readonly exitMs: number;
}

export interface GodCardCopy {
  readonly primary: string;
  readonly secondary: string;
  readonly tertiary?: string;
  readonly boardConfirmation?: string;
}

/** A god is rare enough that Turbo still preserves a deliberate reading pause. */
export function getGodCardTiming(turbo: boolean, reducedMotion: boolean): GodCardTiming {
  if (reducedMotion) return Object.freeze({ enterMs: 0, holdMs: 2_200, exitMs: 0 });
  if (turbo) return Object.freeze({ enterMs: 150, holdMs: 1_500, exitMs: 170 });
  return Object.freeze({ enterMs: 220, holdMs: 2_200, exitMs: 260 });
}

export function getGodCardCopy(event: GodPresentationEvent): GodCardCopy {
  if (event.god === 'RA') {
    const stage = event.raBoostAfter ?? event.raBoostBefore ?? 0;
    if (event.raFullGrid) {
      return Object.freeze({
        primary: `+${event.raAwardedSpins ?? 3} FREISPIELE`,
        secondary: 'STICKY-GRID VOLL',
        tertiary: `RA-STUFE ${stage} · UNVERÄNDERT`,
        boardConfirmation: `+${event.raAwardedSpins ?? 3} FREISPIELE`,
      });
    }
    return Object.freeze({
      primary: `+${event.raAwardedSpins ?? 2} FREISPIELE`,
      secondary: 'WILD-CHANCE ERHÖHT',
      tertiary: `RA-STUFE ${stage} · AB NÄCHSTEM SPIN`,
      boardConfirmation: `RA-STUFE ${stage} AKTIV`,
    });
  }
  if (event.god === 'SLIFER') {
    return Object.freeze({ primary: 'STICKY-WILDS VERSTÄRKT', secondary: 'PERMANENTER MULTIPLIKATOR' });
  }
  const level = event.obeliskLevel ?? 1;
  const affectedCells = event.obeliskCells?.length ?? 3;
  return Object.freeze({
    primary: `OBELISK-STUFE ${level}`,
    secondary: event.obeliskMode === 'full-grid-multiplier'
      ? `${affectedCells} MULTIPLIKATOREN +1`
      : `${affectedCells} FELDER IM EINFLUSSBEREICH`,
    tertiary: 'TEMPORÄR · BIS ZUM NÄCHSTEN SPIN',
  });
}
